import { Targeting } from "../interfaces/TargetingProvider";

export function urlModifier(targeting: Targeting) {
    const params = new URLSearchParams(window.location.search);
    const qsTargeting: Targeting = {};

    for (const [key, value] of params.entries()) {
        qsTargeting[key] = value;
    }

    qsTargeting.url = window.location.pathname;

    return { ...targeting, ...qsTargeting };
}

